import React, { useEffect, useState } from "react";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import { Grid, Container, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import Loading from "../../../../components/shared/loading";
import FormDisplay from "./formDisplay/index.jsx";
import { getDocDetails, getHistoryDetail } from "../../../../redux/docs";
import SubHeader from "./subHeader.jsx";
import ThumbnailBar from "./thumbnailBar.jsx";
import { useLocation, useParams } from "react-router-dom";
import Peoples from "./peoples.jsx";
import Fields from "./fields.jsx";
import History from "./history.jsx";
import TabsHeader from "./tabs/index.jsx";
export const returnPageImage = (file, index) => {
  return `${file?.split("/docs-pdfs")?.[0]}/pg_${index + 1}/docs-pdfs${file
    ?.split("/docs-pdfs")?.[1]
    ?.replace("pdf", "png")}`;
};

const EditDocument = (props) => {
  let { classes } = props;
  const { state } = useLocation();
  // const { formId, fromDataOld } = state;
  const [formData, setFormData] = useState();
  const [activePage, setActivePage] = useState(0);
  const [tab, setTab] = useState(0);
  const { id, form_id } = useParams();
  const dispatch = useDispatch();
  const docDetail = useSelector((item) => item.Docs.docDetail);

  const handleSuccess = (data) => {
    setFormData(data.data?.forms?.find((f) => f.id === parseInt(form_id)));
  };
  useEffect(() => {
    if (id) {
      dispatch(getDocDetails({ id, handleSuccess }));
    }
  }, [id]);

  useEffect(() => {
    if (form_id) {
      dispatch(getHistoryDetail({ id, formId: form_id }));
      setFormData(
        docDetail.data?.forms?.find((f) => f.id === parseInt(form_id))
      );
    }
  }, [form_id]);

  return (
    <div className={classes.pageRoot}>
      <Box sx={{ height: "auto", width: "100%" }}>
        {docDetail.isLoading ? (
          <div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <Box
              sx={{
                p: 8,
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Loading />
            </Box>
          </div>
        ) : (
          formData && (
            <Box>
              <SubHeader
                tab={tab}
                setTab={setTab}
                docDetail={docDetail}
                id={id}
                {...props}
              />
              <TabsHeader {...props} />
              <Box className={classes.documentContainer}>
                <Box className={classes.documentContainerLeft}>
                  <ThumbnailBar
                    docDetail={docDetail}
                    formData={formData}
                    setFormData={setFormData}
                    activePage={activePage}
                    {...props}
                  />
                </Box>
                <Box sx={{ padding: "0px 40px !important", width: "100%" }}>
                  {" "}
                  {tab === 0 ? (
                    <FormDisplay
                      {...props}
                      formData={formData}
                      setFormData={setFormData}
                      setActivePage={setActivePage}
                      activePage={activePage}
                    />
                  ) : tab === 1 ? (
                    <Peoples docDetail={docDetail} id={id} {...props} />
                  ) : tab === 2 ? (
                    <Fields formData={formData} id={id} {...props} />
                  ) : (
                    <History formData={formData} {...props} />
                  )}
                </Box>
              </Box>
            </Box>
          )
        )}
      </Box>
    </div>
  );
};

// export default EditDocument;
export default withStyles(styleSheet, { name: "EditDocumentStyle" })(
  EditDocument
);
